import { FDDialogTitle } from '@facet-wealth/design';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';

export default buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDDialogTitle,
  }, { ordinal: 200 });
